export const AUTH_CONFIG = {
    tokenKey: 'auth_token',
    refreshTokenKey: 'refresh_token',
    tokenExpiryKey: 'token_expiry',
    apiKey: 'api_key_1234567890abcdef',
    apiUrl: 'https://alessandrafilzoli.com/api'
};